import type { AddMaterialType, DeckMaterialKind } from './types';

/**
 * The "+" menu entries, in the design's order (Figma `1:17705`), plus
 * "Record lecture" beside Audio: a live recording is added to a set the same
 * way an audio file is (it lands as an audio source with its own notes).
 */
export const ADD_MATERIAL_TYPES: readonly AddMaterialType[] = [
  'document',
  'photos',
  'mindmap',
  'audio',
  'record',
  'notes',
  'youtube',
];

/**
 * Which display kind an add entry produces. The menu reads its icon through
 * this mapping, so a menu row and the tile it creates can never disagree.
 */
export function materialKindOfAddType(type: AddMaterialType): DeckMaterialKind {
  switch (type) {
    case 'document':
      return 'document';
    case 'photos':
      return 'photos';
    case 'mindmap':
      return 'mindmap';
    case 'audio':
    case 'record':
      return 'audio';
    case 'notes':
      return 'note';
    case 'youtube':
      return 'youtube';
  }
}

/** Entries that attach a NEW source through the create pipeline (vs. opening
 *  the deck's existing note / map). */
export function addTypeAttachesSource(type: AddMaterialType): boolean {
  return type !== 'notes' && type !== 'mindmap';
}
